import { BaseInquiryShiftsWithFlexType } from '../_enums/base-inquiry.enum';

export const BASE_INQUIRY_CALENDAR_MAX_DAYS_TO_SCROLL = 56;
export const BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH = 53;
export const BASE_INQUIRY_CALENDAR_BUFFER_PX_SIZE = 212;
export const BASE_INQUIRY_CALENDAR_MAX_DAYS_TO_SCROLL_SHIFT_PLAN = 42;
export const BASE_STICKY_HEADER_SCROLL_DISTANCE = 138;

export const BASE_INQUIRY_CALENDAR_ORDERED_SHIFTS: BaseInquiryShiftsWithFlexType[] = ['flex', 'fd', 'zd', 'sd', 'nd'];
